<div class="container-fluid">
  <page-header-search
  [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderSearchSubmit)="onSearchPatients($event)"
  ></page-header-search>

  <div *ngIf="filteredPatientsArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">All Emergency Patients</h3>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" *ngFor="let item of filteredPatientsArray">
              <td>
                <span>{{ item.fullName }}</span>
              </td>
              <td>
                <span>{{ item.queueId }}</span>
              </td>
              <td>
                <span>{{ item.status }}</span>
              </td>
              <td>
                <span>{{
                  item.creationDate.split("T")
                    ? item.creationDate.split("T")[0]
                    : item.creationDate
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
